import classNames from "classnames";

import Avatar from "../Avatar";
import { noop } from "@helpers/common";

import styles from "./index.module.scss";

const AvatarWithOnlineStatus = ({
  avatar,
  isOnline,
  className,
  iconClassName,
  isDeleted,
  onClick = noop,
  isBlockedByYou,
  isBlockedByUser,
}) => {
  const isOnlineMarkVisible = isOnline && !isBlockedByYou && !isBlockedByUser;
  return (
    <div
      className={classNames(
        "position-relative",
        isOnlineMarkVisible && styles.online,
      )}
    >
      <Avatar
        onClick={onClick}
        isDeleted={isDeleted}
        avatar={avatar}
        className={className}
        iconClassName={iconClassName}
      />
    </div>
  );
};

export default AvatarWithOnlineStatus;
